import { render, staticRenderFns } from "./SendPostSMS.vue?vue&type=template&id=b62ae9be&scoped=true&"
import script from "./SendPostSMS.vue?vue&type=script&lang=js&"
export * from "./SendPostSMS.vue?vue&type=script&lang=js&"
import style0 from "./SendPostSMS.vue?vue&type=style&index=0&id=b62ae9be&scoped=true&lang=scss&"
import style1 from "../../Auth/AuthModal/AuthModal.scss?vue&type=style&index=1&id=b62ae9be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62ae9be",
  null
  
)

export default component.exports